import { CommonState } from '../../models/commonState';
import { SET_THEME } from './commonActionTypes';

type Action = {
  type: string;
  payload: any;
};

const initialState: CommonState = {
  theme: ''
};

const commonReducer = (state = initialState, action: Action): CommonState => {
  switch (action.type) {

    case SET_THEME: {
      return {
        ...state,
        theme: action.payload,
      };
    }

    default: {
      return state;
    }
  }
};

export default commonReducer;
